export default {"src":"/_next/static/media/logo.6818e26d.svg","height":1214,"width":4037,"blurWidth":0,"blurHeight":0};